export default "__VITE_ASSET__BMBDCgnC__"